function Header() {
    return (
        <header>
            <nav>
                <ul>
                    <li><a href="#stack">Stack</a></li>
                    <li><a href="#projects">Projets</a></li>
                    <li><a href="#contact">Contact</a></li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;